import { isFiniteNumber, parseStringRecord, StringRecord } from "./storageValidation";

const DRAW_COUNTS_KEY = "kanalearn.kanjiDrawCounts.v1";
export type KanjiDrawCounts = StringRecord<number>;

export function getDrawCounts(): KanjiDrawCounts {
    try {
        const raw = localStorage.getItem(DRAW_COUNTS_KEY);
        return parseStringRecord(raw, isFiniteNumber);
    } catch {
        return {};
    }
}

export function setDrawCounts(counts: KanjiDrawCounts): void {
    try {
        localStorage.setItem(DRAW_COUNTS_KEY, JSON.stringify(counts));
    } catch {
        // Best-effort: if storage is unavailable, counts just won't persist.
    }
}
